// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1bCqQ","modalForm":"UpgradeEpcsModal_modalForm__18QYj","modalFooter":"UpgradeEpcsModal_modalFooter__1Y5m4"};